import { useQuery } from '@tanstack/react-query'
import { jsonFetch } from '@/lib/api/jsonFetch'
import type { ActionsResponse } from './types'

export function useActionHistory(limit = 500) {
  return useQuery({
    queryKey: ['action-history', 'list', limit],
    queryFn: () =>
      jsonFetch<ActionsResponse>(
        `/api/actions/history?${new URLSearchParams({ limit: String(limit) }).toString()}`,
      ),
    staleTime: 30_000,
  })
}
